export const Ranks = [
  {
    company: "LeetCode",
    class: "class 12",
    // dateJoining: "2021",
    dateEnd: "2022",
    logo: "https://leetcode.com/static/images/LeetCode_Sharing.png",
    description: "Solved 600+ DSA problems.",
    link: "https://leetcode.com/Tariqrasheed/",
  },
  {
    company: "GeeksForGeeks:",
    class: "class 12th",
    // dateJoining: "2019",
    dateEnd: "2022",
    logo: "https://repository-images.githubusercontent.com/389729275/371ba38b-8a03-4bff-916c-c3fa5396ceda",
    description:"Solved 1k+ DSA problems",
    link: "https://auth.geeksforgeeks.org/user/tariq123",
  },
  {
    company: "CodeForces:",
    class: "class 12th",
    // dateJoining: "2019",
    dateEnd: "2023",
    logo: "https://qph.cf2.quoracdn.net/main-qimg-ef104c0916998d7e51983d3900ae8588-lq",
    description:"rating: Pupil at codeforces",
    link: "https://codeforces.com/profile/TARIQ_123",
  },
  {
    company: "Semicolon",
    class: "class 12th",
    // dateJoining: "2019",
    dateEnd: "2021",
    logo:"https://t4.ftcdn.net/jpg/03/17/11/69/360_F_317116906_eDkkuz2gFs0WamvupMTHwLPAIENS8O9c.jpg",
    // logo:require("../../assets/1656670179400.png"),
    description: "Inter NIT coding competition, Rank 3",
    link: "https://codeforces.com/gym/379275/standings",
  },
  {
    company: "Google",
    class: "B-tech 2nd Year",
    // dateJoining: "2021",
    dateEnd: "2021",
    logo: "https://mladiinfo.eu/wp-content/uploads/2019/03/kickstart-fb.jpg",
    description: "Google kickStart round B Global Rank: 1774",
    link: "https://github.com/tariqrasheed172001/web/blob/main/screenshots/00000000008caba4%20(2).pdf",
  },
  {
    company: "CodeChef",
    class: "class 12th",
    // dateJoining: "2019",
    dateEnd: "2021",
    logo:"https://upload.wikimedia.org/wikipedia/en/thumb/7/7b/Codechef%28new%29_logo.svg/1200px-Codechef%28new%29_logo.svg.png",
    description: "codechef Starters,  Global Rank 92",
    link: "https://www.codechef.com/rankings/START31D?itemsPerPage=100&order=asc&page=1&sortBy=rank",
  },
];
